import type { HandSplitOptions } from "../engine/hand-split";

// Per-song hand-split overrides (swap + split bias), keyed by song id.

const KEY = "drop-notes.song-overrides";

function clampBias(value: unknown): number {
  if (typeof value !== "number" || !Number.isFinite(value)) return 0;
  return Math.max(-5, Math.min(5, Math.round(value)));
}

export function loadOverride(songId: string): HandSplitOptions {
  try {
    const raw = localStorage.getItem(KEY);
    if (raw) {
      const map = JSON.parse(raw) as Record<string, Partial<HandSplitOptions>>;
      const o = map[songId];
      if (o) return { swap: o.swap === true, biasSemitones: clampBias(o.biasSemitones) };
    }
  } catch {
    // ignore corrupt/blocked storage
  }
  return { swap: false, biasSemitones: 0 };
}

export function saveOverride(songId: string, opts: HandSplitOptions): void {
  try {
    const raw = localStorage.getItem(KEY);
    const map = raw ? (JSON.parse(raw) as Record<string, HandSplitOptions>) : {};
    map[songId] = { swap: opts.swap, biasSemitones: clampBias(opts.biasSemitones) };
    localStorage.setItem(KEY, JSON.stringify(map));
  } catch {
    // ignore — overrides simply won't persist
  }
}
